module.exports = __webpack_public_path__ + "media/images/actions-topbar-78a8a82ba00180bcb590d37a75e55e73.svg";